
import { Vue, Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { toAddress } from "@/utils/h5ToApp";
import {
  GetCompanyDtl,
  getCompareCode,
  bindingVersionCode,
} from "@/api/company";
import { setAllowsBackGesture } from "@/utils/h5ToApp";

@Component({
  components: {},
})
export default class Workbench extends Vue {
  @Getter companyId!: string;
  @Getter isMultiStore!: boolean;
  @Getter multiStoreList!: (string | number)[];
  show = false;
  versionCode = "";
  onlyReadVersionCode = ""; // 只读渠道邀请码
  list: any[] = [
    {
      title: "店铺管理",
      grid: [
        {
          label: "新增商品",
          src: require("@/assets/images/shouyin/shopManage/add-goods.png"),
          path: "/addGoodsAssociate",
        },
        {
          label: "商品管理",
          src: require("@/assets/images/shouyin/shopManage/goods-manage.png"),
          path: "/goodsManage",
        },
        {
          label: "营销活动",
          src: require("@/assets/images/shouyin/shopManage/market-activity.png"),
          path: "/marketActivity",
        },
        {
          label: "卡券管理",
          src: require("@/assets/images/shouyin/shopManage/coupon-manage.png"),
          path: "/couponManage",
        },
        {
          label: "订单查询",
          src: require("@/assets/images/shouyin/shopManage/order-manage.png"),
          path: "/storeOrderManage",
        }
      ],
    },
    {
      title: "常常鲜微店",
      grid: [
        {
          label: "微店商品",
          src: require("@/assets/images/shouyin/shopManage/shop.png"),
          path: "/weidianGoodsManage"
          // path: "/jieLongOrder"
        },
        {
          label: "次日达管理",
          src: require("@/assets/images/shouyin/shopManage/nextday.png"),
          path: "/shelf",
        },
        {
          label: "次日达订单",
          src: require("@/assets/images/shouyin/shopManage/sales-order.png"),
          path: "/salesSlip",
        },
        {
          label: "接龙管理",
          src: require("@/assets/images/shouyin/shopManage/jielong-manage.png"),
          path: "/jieLongList",
        },
        {
          label: "促销活动",
          src: require("@/assets/images/shouyin/shopManage/promotions.png"),
          path: "/salespromotion",
        },
        {
          label: "销售统计",
          src: require("@/assets/images/shouyin/shopManage/sales-statistics.png"),
          path: "/salesstatistics",
        },
      ],
    },
    {
      title: "门店采购",
      grid: [
        {
          label: "采购商城",
          src: require("@/assets/images/shouyin/shopManage/purchase-mall.png"),
          path: "/mall",
        },
        {
          label: "分类商城",
          src: require("@/assets/images/shouyin/shopManage/category-mall.png"),
          path: "/mallCategory",
        },
        {
          label: "购物车",
          src: require("@/assets/images/shouyin/shopManage/cart.png"),
          path: "/buyMallCar",
        },
        {
          label: "采购单",
          src: require("@/assets/images/shouyin/shopManage/purchase-order.png"),
          path: "/orderMall",
        },
        {
          label: "关注店铺",
          src: require("@/assets/images/shouyin/shopManage/follow-store.png"),
          path: "/storeCollectList",
        },
        {
          label: "地址管理",
          src: require("@/assets/images/shouyin/shopManage/address-manage.png"),
          // path: "/address-manage",
          path: "/addressManage",
        },
        {
          label: "版本管理",
          src: require("@/assets/images/shouyin/shopManage/version-manage.png"),
          path: "/version",
        },
        {
          label: "渠道邀请码",
          src: require("@/assets/images/shouyin/shopManage/invite-code.png"),
          path: "/invite-code",
        },
      ],
    },
    {
      title: "通用功能",
      grid: [
        {
          label: "实名认证",
          src: require("@/assets/images/shouyin/shopManage/authenticate.png"),
          path: "/companyInfoForm?formPage=h5",
        },
      ],
    },
  ];

  onGridItemClick(item) {
    const { path } = item;
    // if (path === "/address-manage") {
    //   toAddress();
    //   return;
    // }
    if (path === "/invite-code") {
      this.showInviteCode();
      return;
    }
    path && this.$router.push(path);
    console.log(
      "%c 🍝 item: ",
      "font-size:12px;background-color: #42b983;color:#fff;",
      item
    );
  }

  // input输入限制（英文、数字）独立编码
  formatterInput(value) {
    return value.replace(/[^a-zA-Z\d]/g, "").toUpperCase(); // 大写英文和数字
  }

  // 显示渠道邀请码
  showInviteCode() {
    this.show = true;
    GetCompanyDtl({ companyId: this.companyId }).then((res) => {
      this.onlyReadVersionCode = res.data.versionCode || "";
      this.versionCode = this.onlyReadVersionCode;
    });
  }

  bindingVersionCode() {
    if (this.onlyReadVersionCode) return;
    if (this.$checkIsEmpty(this.versionCode)) {
      this.$toast("请输入渠道邀请码");
      return false;
    }
    // 匹配邀请码 判断填写的邀请码是否有效
    getCompareCode({ versionCode: this.versionCode })
      .then((res) => {
        let params = {
          type: "1", // 邀请码or版本码
          versionCode: this.versionCode,
        };
        // 绑定邀请码
        bindingVersionCode(params)
          .then((res) => {
            this.show = false;
            this.$toast.success({
              message: `绑定成功`,
              duration: 1000,
              onClose: () => {
                this.show = false;
              },
            });
          })
          .catch((err) => {
            this.$toast(err.data.msg);
          });
      })
      .catch((err) => {
        this.$toast(err.data.msg);
      });
  }

  // 是否禁用侧滑返回
  setAllowsBackGesture(isAllow: boolean) {
    setAllowsBackGesture(isAllow ? '1' : '0');
  }

  mounted() {
    this.setAllowsBackGesture(false);
  }
  beforeDestroy() {
    this.setAllowsBackGesture(true);
  }
}
